import { useParams } from 'react-router-dom';

const useAutomationId = () => {
  // only use when inside an automation
  const { automationId } = useParams<{ automationId: string }>();
  return automationId!;
};
export default useAutomationId;
